function returnOptions(data) {
  // 重置定义数组
  const newList = data.map((item) => ({
    value: item.customerCount,
    name: item.typeName,
  }));
  const arr = data.map((item) => item.customerCount);
  // 计算总和
  let sum = 0;
  for (let i = 0; i < arr.length; i++) {
    sum += arr[i];
  }
  // const total = arr[0] + arr[1];
  return {
    color: ['#fe6d6c', ' #20a0ff'],
    title: {
      show: true,
      text: '新增顾客统计',
      subtext: `新增顾客总人数：${sum}`,
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} <br/>占比：{d}%'
    },
    legend: {
      orient: 'vertical',
      left: 'right',
    },
    series: [{
      type: 'pie',
      center: ['50%', '65%'],
      // radius: '70%',
      radius: ['30%', '70%'],
      avoidLabelOverlap: false,
      label: {
        // 饼图图形上的文本标签
        normal: {
          show: true,
          position: 'center', // 标签的位置
          textStyle: {
            fontWeight: 300,
            fontSize: 12, // 文字的字体大小
            color: '#fff',
          },
          formatter: '{d}%',
        },
      },
      labelLine: {
        show: false
      },
      data: newList
    },
    ]
  };
}
export const echartsD = returnOptions;
